enum ModalClassType {
  LL = 'LL',
  LW = 'LW'
}

export { ModalClassType }
